import { ContactInfo } from './contactInfo';
import { User } from './user';
import { Project } from './project';
import { Proposal } from './proposal';
import { Address } from './address';
import type { PoPriceTier } from './item';

export enum PurchaseOrderStatus {
  Draft = 1,
  NewEntered,
  Paid,
  PaidEntered,
  Void
}

export interface PurchaseOrder {
  id: string;
  purchaseOrderNumber: string;
  // item 465 — Service Address (end-user); serviceName is the required name, rest optional
  serviceName?: string;
  serviceAddress?: Address;
  servicePhone?: string;
  serviceEmail?: string;
  clientPoNumber?: string; // item 672 — the client's PO number, printed under the shipping address
  trackingUrl?: string | null; // item 1310 — shipment tracking link, carried PO → SO → invoice
  sentDate?: string | null; // item 1320 — when it was emailed to the vendor (SENT chip on the ledger)
  shippingInstructions?: string; // item 798 — required shipping method (Ground/Two-Day/Overnight…)
  itemCategories: string;
  date: string;
  discount: number;
  discountReason: string;
  requestedBy: string;
  internalNotes: string;
  vendorId: string;
  proposalId: string;
  workOrderId: string;
  invoiceId: string;
  salesRepId: string;
  projectManagerId: string;
  total: number;
  status: PurchaseOrderStatus;
  isArchive: boolean;
  isVoid: boolean;
  createdById: string;
  createdDate: string;
  lastModifiedById: string;
  lastModifiedDate: string;
  projectId: string;
  project: Project;
  createdBy: User;
  vendor: ContactInfo;
  proposal: Proposal;
  salesRep: User;
  projectManager: User;
  lastModifiedBy: User;
  purchaseOrderItems: PurchaseOrderItem[];
  isLocked: boolean;
}

export interface PurchaseOrderItem {
  id: string;
  itemId: string;
  category: string;
  sku: string;
  brand: string;
  description: string;
  quantity: number;
  costEach: number;
  taxable: boolean;
  vendorId?: string;
  // item 554 — the three-tier hardware pricing carried on a PO line: DISTO (costEach, the buy
  // price + the only thing on the vendor PDF) → GROUP PRICE (retailEach, sell price) → MSRP
  // (listPrice). Group/MSRP are editor reference (seeded from the catalog markups, like the
  // invoice); the PDF outputs DISTO only. Labor / custom lines carry just costEach.
  retailEach?: number;
  listPrice?: number;
  isHardware?: boolean;
  // item 290 — which cost tier this line buys at (Dealer vs Distributor). costEach holds
  // the resulting price (so the total + backend are unaffected); the tier + the snapshotted
  // dealer/distributor prices let the per-line selector swap the price without a catalog
  // round-trip. Frontend-only: the backend ignores these extra members on save.
  priceTier?: PoPriceTier;
  dealerCostEach?: number;
  distributorCostEach?: number;
}

export interface PurchaseOrdersDto {
  index: PurchaseOrder[];
  length: number;
}
